import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { getGhaInfo } from '../../../store/actions/ghaAction';
import { receiveError } from '../../../store/actions/notificationAction';

import GhaInfo from './ghaInfo';
import GhaInfoModal from './ghaInfoModal';
import DockerOverloadModalContainer from '../../dockOverloadModal/DockerOverloadModalContainer';

import GhaModel from '../../../models/Gha';
import ResponseError from '../../../models/ResponseError';

interface GhaInfoState {
  openModalInfo: boolean;
  openDockOverloadModal: boolean;
};

interface GhaInfoProps { 
  ghaId: number;
  type: 'import'| 'export';
  receiveError: Function;
  getGhaInfo: Function;
  gha: GhaModel;
};

class GhaInfoContainer extends Component <GhaInfoProps, GhaInfoState> {
  state = {
    openModalInfo: false,
    openDockOverloadModal: false
  };

  getGha = (): void => {
    this.props.getGhaInfo(this.props.ghaId);
  };

  handleCloseModalInfo = (): void => {
    this.setState({ openModalInfo: false });
  };

  handleCloseDockOverloadModal = (time: string): void => {
    this.setState({ openDockOverloadModal: false });
  };

  handleOpenModalInfo = (): void => {
    this.setState({ openModalInfo: true });
  };

  handleOpenDockOverloadModal = (): void => {
    this.setState({ openDockOverloadModal: true });
  };

  componentDidMount(){
    if (this.props.ghaId !== -1) {
      this.getGha();
    }
  };

  componentDidUpdate(prevProps: GhaInfoProps) {

    const newProps: GhaInfoProps = this.props;

    if (prevProps.ghaId !== newProps.ghaId && newProps.ghaId !== -1) {
      this.getGha();
    };
  };
    
  render() {

    return (
      <Fragment>
        { this.props.gha.id !== -1 &&  
          <GhaInfo 
            gha={ this.props.gha }
            handleOpenModalInfo={ this.handleOpenModalInfo }
            handleOpenDockOverloadModal={ this.handleOpenDockOverloadModal }
          />
        }
        { this.state.openModalInfo && 
          <GhaInfoModal
            gha={ this.props.gha }
            modalOpen= { this.state.openModalInfo }
            handleClose={ this.handleCloseModalInfo }
            type={ this.props.type }
          />
        }
        { this.state.openDockOverloadModal &&
          <DockerOverloadModalContainer
            openDockOverloadModal={ this.state.openDockOverloadModal }
            handleCloseDockOverloadModal={ this.handleCloseDockOverloadModal }
            forInfo={ true }
            ghaID={ this.props.gha.id }
            type={ this.props.type }
            date={ '' }
            time={ '' }
          />
        }
      </Fragment>
    )
  };
};

const mapStateToProps = (state: any, props: any) => {
  return {
    gha: state.ghaInfo,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    getGhaInfo: (ghaId: number) => dispatch(getGhaInfo(ghaId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GhaInfoContainer);